import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Button = styled.button`
  border: none;
  background-color: ${ColorPalette.Transparent};
  cursor: pointer;
`;

export const Img = styled.img``;
